import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { xosoService } from "@/services/xosoService";
import { drawDateKey, HISTORY_DRAWS, historyDates } from "./constants";

dayjs.extend(utc);

export default function useDienToan6x36(date, days = HISTORY_DRAWS) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolvedDate, setResolvedDate] = useState(date || null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      let latest = null;
      let anchor = date || null;
      if (!anchor) {
        latest = await xosoService.getDienToan6x36();
        anchor = drawDateKey(latest?.drawDate);
        if (!anchor) {
          if (!cancelled) {
            setResults([]);
            setResolvedDate(null);
            setLoading(false);
          }
          return;
        }
      }

      const dates = days <= 1 ? [anchor] : historyDates(anchor, days);
      const items = (
        await Promise.all(
          dates.map((d) => {
            if (latest && d === anchor) return Promise.resolve(latest);
            return xosoService.getDienToan6x36({ date: d });
          })
        )
      ).filter(Boolean);
      items.sort((a, b) => dayjs(b.drawDate).valueOf() - dayjs(a.drawDate).valueOf());

      if (!cancelled) {
        setResults(items);
        setResolvedDate(anchor);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [date, days]);

  return { results, loading, resolvedDate };
}
